import api from '.';

export interface CreateProjectAccessControlUsers {
  projectId: number;
  projectAccessControlUsers: {
    userId: number;
    accessControlIds: number[];
  }[];
}

export async function getProjectAccessControlUsers(projectId: number) {
  const params = { projectId };
  const { data } = await api.get('/project-access-control-users', { params });
  return data;
}

export async function createProjectAccessControlUsers({
  projectId,
  projectAccessControlUsers
}: CreateProjectAccessControlUsers) {
  const createProjectAccessControlUsers = {
    projectId,
    projectAccessControlUsers
  };
  const { data } = await api.post(
    '/project-access-control-users',
    createProjectAccessControlUsers
  );
  return data;
}

export async function updateProjectAccessControlUsers({
  projectId,
  projectAccessControlUsers
}: CreateProjectAccessControlUsers) {
  const updateProjectAccessControlUsers = {
    projectId,
    projectAccessControlUsers
  };
  const { data } = await api.put(
    '/project-access-control-users',
    updateProjectAccessControlUsers
  );
  return data;
}

export function deleteProjectAccessControlUsers({
  projectId,
  userId
}: {
  projectId: number;
  userId: number;
}) {
  const params = { projectId, userId };
  return api.delete('/project-access-control-users', { params });
}
